import { render, staticRenderFns } from "./addUser2.vue?vue&type=template&id=2c1f6f0e&scoped=true&"
import script from "./addUser2.vue?vue&type=script&lang=js&"
export * from "./addUser2.vue?vue&type=script&lang=js&"
import style0 from "./addUser2.vue?vue&type=style&index=0&id=2c1f6f0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f6f0e",
  null
  
)

export default component.exports